export enum GlobalContextActionTypes {
    SetHandleCaseSave = 'SET_HANDLE_CASE_SAVE'
}
export type ReducerAction = {
    type: GlobalContextActionTypes;
    payload?: unknown;
};
